import * as React from "react";
const SvgRename = props => <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" {...props}><path d="m14.06 9.02.92.92L5.92 19H5v-.92zM17.66 3a1 1 0 0 0-.7.29l-1.83 1.83 3.75 3.75 1.83-1.83a1 1 0 0 0 0-1.41l-2.34-2.34a.98.98 0 0 0-.71-.29m-3.6 3.19L3 17.25V21h3.75L17.81 9.94z" data-name="Trazado 692" style={{
    fill: "rgba(60,60,60,.4)"
  }} /></svg>;
export { SvgRename as ReactComponent };